import React, { useRef, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'
import { IoIosReturnRight } from "react-icons/io";
import { BsPersonCheckFill, BsClock, BsExclamationTriangle, BsClipboardCheck } from "react-icons/bs";
import { MdOutlineAreaChart } from "react-icons/md";
import DateFilter from './Components/Dates/DateFilter';
import UniversalFilter from '../../../../CommonElements/FilterComponent/UniversalFilter';
import Loader1 from "../../../../CommonElements/Spinner/loader";

export default function SupervisorCardForArea({ data, setfilters, loading }) {

    //   const currentWeekk = getCurrentWeekWithYear();

    return (
        <div className='pb-3'>
              <div className='d-flex justify-content-between align-items-center  '>
            <div className='d-flex justify-content-between align-items-center gap-3 ps-3 mb-4' style={{
                borderInlineStart: "4px solid #1768db",
                paddingLeft: "1rem"
            }}>
                <div className='icon-container' style={{
                    background: "linear-gradient(135deg, #1768db, #4a90e2)",
                    padding: "10px",
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(23, 104, 219, 0.2)"
                }}>
                    <BsPersonCheckFill size={24} style={{ color: "white" }} />
                </div>
                <div>
                    <h4 className='mb-0 fw-bold' style={{ color: "#2c3e50" }}>Supervisors</h4>
                    <p className='text-muted mb-0 small'>Manage and monitor supervisor activities</p>
                </div>
            </div>
          
                <UniversalFilter setfilters={setfilters} />
            </div>

            {
                loading ? <Loader1 /> : <>
                    {
                        data?.length > 0 ? (
                            <Row className='g-4'>
                                {
                                    data?.slice() 
                                    .sort((a, b) => b.alerts - a.alerts) 
                                    .map((supervisorData, index) => (
                                        <Col xl='4' lg='6' md='6' sm='12' key={index}>
                                            <Card className='supervisor-card h-100' style={{
                                                border: "none",
                                                borderRadius: "16px",
                                                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
                                                transition: "all 0.3s ease",
                                                background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                                                overflow: "hidden"
                                            }}>
                                                {/* Card Header */}
                                                <CardHeader style={{
                                                    background: "linear-gradient(135deg, #1768db, #4a90e2)",
                                                    border: "none",
                                                    padding: "1.5rem"
                                                }}>
                                                    <div className='d-flex justify-content-between align-items-center'>

                                                        <h5 className='mb-0 text-white fw-semibold'>
                                                            {supervisorData.names?.join(', ')}
                                                        </h5>

                                                        <div style={{
                                                            background: "rgba(255, 255, 255, 0.2)",
                                                            padding: "8px",
                                                            borderRadius: "10px",
                                                            backdropFilter: "blur(10px)"
                                                        }}>
                                                            <BsPersonCheckFill size={16} style={{ color: "white" }} />
                                                        </div>
                                                    </div>
                                                </CardHeader>

                                                <CardBody className='p-4'>
                                                    {/* Assigned Subarea */}
                                                    <div className='info-item d-flex align-items-center mb-3 p-3' style={{
                                                        background: "rgba(23, 104, 219, 0.05)",
                                                        borderRadius: "12px",
                                                        border: "1px solid rgba(23, 104, 219, 0.1)"
                                                    }}>
                                                        <div className='icon-wrapper me-3' style={{
                                                            background: "linear-gradient(135deg, #1768db, #4a90e2)",
                                                            padding: "8px",
                                                            borderRadius: "10px"
                                                        }}>
                                                            <MdOutlineAreaChart size={18} style={{ color: "white" }} />
                                                        </div>
                                                        <div className='flex-grow-1'>
                                                            <span className='text-primary fw-semibold'>Assigned Subarea</span>
                                                            <div className='text-dark small mt-1'>{supervisorData.subarea}</div>
                                                        </div>
                                                    </div>

                                                    {/* Metrics Row */}
                                                    <Row className='g-3 mb-3'>
                                                        <Col xs='6'>
                                                            <div className='metric-card text-center p-3' style={{
                                                                background: "rgba(255, 193, 7, 0.1)",
                                                                borderRadius: "12px",
                                                                border: "1px solid rgba(255, 193, 7, 0.2)"
                                                            }}>
                                                                <BsExclamationTriangle size={20} style={{ color: "#ffc107" }} className='mb-2' />
                                                                <div className='metric-value fw-bold' style={{ color: "#2c3e50" }}>
                                                                    {supervisorData.alerts}
                                                                </div>
                                                                <div className='metric-label small text-muted'>Subarea Alerts</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs='6'>
                                                            <div className='metric-card text-center p-3' style={{
                                                                background: "rgba(40, 167, 69, 0.1)",
                                                                borderRadius: "12px",
                                                                border: "1px solid rgba(40, 167, 69, 0.2)"
                                                            }}>
                                                                <BsClipboardCheck size={20} style={{ color: "#28a745" }} className='mb-2' />
                                                                <div className='metric-value fw-bold' style={{ color: "#2c3e50" }}>
                                                                    {supervisorData.compliance}%
                                                                </div>
                                                                <div className='metric-label small text-muted'>Compliance</div>
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    {/* Shift Information */}
                                                    <div className='shift-info p-3' style={{
                                                        background: "rgba(108, 117, 125, 0.05)",
                                                        borderRadius: "12px",
                                                        border: "1px solid rgba(108, 117, 125, 0.1)"
                                                    }}>
                                                        <div className='d-flex align-items-center mb-2'>
                                                            <BsClock size={16} className='me-2 text-muted' />
                                                            <span className='fw-semibold text-dark'>Shift Details</span>
                                                        </div>
                                                        <div className='d-flex justify-content-between align-items-center'>
                                                            <span className='text-muted small'>{supervisorData.shift}</span>
                                                            <span className='text-dark small fw-semibold'>{supervisorData.timing}</span>
                                                        </div>
                                                    </div>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                    ))
                                }
                            </Row>
                        ) : (
                            /* Empty State */
                            <div className='text-center py-5' style={{
                                background: "linear-gradient(135deg, #f8fafc 0%, #e9ecef 100%)",
                                borderRadius: "16px",
                                border: "2px dashed #dee2e6"
                            }}>
                                <BsPersonCheckFill size={48} style={{ color: "#6c757d", opacity: 0.5 }} className='mb-3' />
                                <h5 className='text-muted'>No Supervisors Found</h5>
                                <p className='text-muted mb-0'>There are currently no supervisors assigned to this area.</p>
                            </div>
                        )
                    }
                </>
            }




        </div>
    )
}